<template>
  <div :class="['input-form-wrap-row','spacing-height',inputStyleClass]">
    <div class="input-label">
      <span style="color:red" v-if="required">*</span>
      <span>{{ label }}</span>
    </div>
    <el-input
      class="input-form"
      :style="customStyle"
      :value="value"
      @input="handleInput"
      size="mini"
      :readonly="readonly"
    />
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    value: [String, Number],
    readonly: Boolean,
    required: Boolean,
    customStyle: Object,
    inputClass: String
  },
  computed: {
      inputStyleClass() {
        return this.inputClass ? `el-input-${this.inputClass}` : '';
      }
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/style/plant";
  .el-input-contact {
    .el-input /deep/ .el-input__inner {
      color: var(--inputColorContact);
    }
  }

  .el-input-phone {
    .el-input /deep/ .el-input__inner {
      color: var(--inputColorPhone);
    }
  }

  .el-input-patient {
    .el-input /deep/ .el-input__inner {
      color: var(--inputColorPatient);
    }
  }

  .input-form {
    width: 186px;
    height: 40px;
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// InputField.vue?c1d7665c